import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getSessionUser } from '@/lib/session';
import { normalizeRole } from '@/auth/permissions';
import { getHomePathForRole } from '@/utils/roleRouting';
import { toast } from '@/lib/toast';
import { canViewAgendaEquipo } from '@/auth/agendaAccess';

type RequireAgendaEquipoProps = {
  children: ReactElement;
};

export default function RequireAgendaEquipo({ children }: RequireAgendaEquipoProps) {
  const location = useLocation();
  const user = getSessionUser();
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const role = normalizeRole(user.role);
  const email = typeof user.email === 'string' ? user.email : null;
  const isAdmin = role === 'ADMIN' || role === 'GERENTE_INV';

  if (!isAdmin && !canViewAgendaEquipo(email)) {
    toast('No tienes acceso a la agenda del equipo', 'warning');
    const fallback = role === 'CONSULTA' ? '/inventario' : getHomePathForRole(role);
    return <Navigate to={fallback} replace state={{ from: location }} />;
  }

  return children;
}
